import { useMutation, useQueryClient } from '@tanstack/react-query';
import { revokeAdmin } from '../services/admins';
import { adminQueryKeys } from './query-keys';

export const useRevokeAdminMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userId) => {
      const result = await revokeAdmin(userId);
      if (!result.success) {
        throw new Error(result.message || 'Failed to revoke admin access');
      }
      return result.data;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: adminQueryKeys.all });
      options.onSuccess?.(...args);
    },
    ...options,
  });
};
